import BigNumber from 'bignumber.js';

import { OrderSide, OrderType, InstrumentT } from 'types';

export const countMinMaxAmount = (
  limitPrice: number,
  instrument: InstrumentT,
  orderType: OrderType,
  orderSide: OrderSide
) => {
  const {
    min_quantity,
    max_quantity,
    quote_currency: { precision: quotePrecision },
  } = instrument;
  const quantities = {
    minQuantity: min_quantity as number,
    maxQuantity: max_quantity as number,
  };

  if (orderType === OrderType.Limit) {
    if (orderSide === OrderSide.Buy) {
      let limit = limitPrice;

      if (!limit) {
        // show Max trade size due to current price
        limit = instrument.price.ask;
      }

      quantities.minQuantity = Number(
        BigNumber(limit).multipliedBy(min_quantity).toFixed(quotePrecision, BigNumber.ROUND_UP)
      );
      quantities.maxQuantity = limit * max_quantity;
    }
  } else {
    if (orderSide === OrderSide.Buy) {
      quantities.minQuantity = instrument.min_quote_quantity;
      quantities.maxQuantity = instrument.max_quote_quantity;
    }
  }

  return quantities;
};
